import React from 'react';
import { useSelector } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';

const columns = [
  {
    field: 'field',
    headerName: '',
    width: 150,
    height: 10,
    // renderCell: (params) => <div className="rounded-section" style={{ background: '#43F90D' }} />,
    align: 'center',
    customHeadRender: () => null,
  },
  {
    field: 'value',
    headerName: '',
    flex: 1,
    height: 10,
    customHeadRender: () => null,
  },
];

const NodeDetails = () => {
  const nodeDetails = useSelector((state) => state?.fuse?.dashboard?.nodeDetails?.generalInfo);
  const nodeSelected = useSelector((state) => state?.fuse?.dashboard?.nodeDetails?.metricsGraphic?.nodeSelected);
  const setEstadoEquipo = (value) => {
    if (value === '2') {
      return 'Verde';
    }
    if (value === '0') {
      return 'Rojo';
    }
    if (value === '1') {
      return 'Amarillo';
    }
    return 'Inactivo';
  };

  const rows = [
    // { id: 1, field: 'Estatus', value: setEstadoEquipo(nodeDetails?.estadoequipo) },
    { id: 9, field: 'Nombre', value: nodeDetails?.dsnodo || nodeSelected },
    { id: 2, field: 'Dirección IP', value: nodeDetails?.ip },
    { id: 3, field: 'Disponibilidad', value: nodeDetails?.disponibilidad || 'Sin datos' },
    { id: 4, field: 'CPU', value: Number(nodeDetails?.cpu || 0).toFixed(2) },
    { id: 5, field: 'Grupo Inmueble', value: nodeDetails?.dsgrupoinmueble },
    { id: 6, field: 'Criticidad', value: nodeDetails?.dscriticidad },
    { id: 7, field: 'Tipo de Dispositivo', value: nodeDetails?.dstipodispositivo },
    { id: 8, field: 'Servicio', value: nodeDetails?.servicio },
  ];

  return (
    <div
      className="flex max-w-full gap-0 m-10 flex-col"
      style={{ display: 'flex', flexDirection: 'column', height: '71%' }}
    >
      <strong className="title-chart" style={{ marginTop: '10px', marginBottom: '10px' }}>
        Detalles del Nodo
      </strong>
      <DataGrid headerHeight={0} rows={rows} columns={columns} disableRowSelectionOnClick hideFooter />
    </div>
  )
}

export default NodeDetails;
